import React from 'react';
import { FadeIn } from './FadeIn';
import { DollarSign, AlertCircle, Settings } from 'lucide-react';
const filters = [{
  title: 'Rentabilidad',
  icon: DollarSign,
  description: '¿Esta tarea justifica mi tarifa premium o es trabajo de bajo valor?'
}, {
  title: 'Urgencia Real',
  icon: AlertCircle,
  description: '¿Es verdaderamente urgente o es solo la ansiedad del cliente?'
}, {
  title: 'Automatización',
  icon: Settings,
  description: '¿Puedo delegar esto a un sistema antes de tocarlo yo misma?'
}];
export function TripleFilterSection() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-159">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-161">
          <div data-id="element-162">
            <FadeIn data-id="element-163">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-6" data-id="element-164">
                Presentamos el{' '}
                <span className="text-brand-gold" data-id="element-165">
                  Sistema de Triple Filtro VIP
                </span>
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-166">
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-167">
                A diferencia de los métodos de gestión de tiempo tradicionales,
                este sistema obliga a cada tarea a pasar por tres puertas
                críticas antes de que tú le dediques un solo minuto.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-168">
              <p className="text-lg text-brand-charcoal/80 leading-relaxed font-medium" data-id="element-169">
                No organizas el caos; lo eliminas antes de que llegue a tu
                calendario. Es la diferencia entre ser una secretaria que
                ejecuta y una Operadora de Élite que lidera.
              </p>
            </FadeIn>
          </div>

          <div className="space-y-6" data-id="element-170">
            {filters.map((filter, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-171">
                <div className="flex items-start space-x-6 p-6 bg-brand-cream border-l-4 border-brand-gold rounded-r-sm" data-id="element-172">
                  <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-173">
                    <filter.icon className="w-6 h-6 text-brand-gold" data-id="element-174" />
                  </div>
                  <div data-id="element-175">
                    <h3 className="text-xl font-bold text-brand-charcoal mb-2 font-sans" data-id="element-176">
                      {index + 1}. {filter.title}
                    </h3>
                    <p className="text-brand-charcoal/70" data-id="element-177">
                      {filter.description}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}